import { useSelector } from 'react-redux';
import { ReduxState } from '../store';
import { useGetUserProjectsQuery } from '../apis/apiApplication';
import { useMemo } from 'react';

export function useCurrency(): string {
  const projectShortName = useSelector(
    (state: ReduxState) => state.userReducer.selectedProjectShortName,
  );
  const { data: projects } = useGetUserProjectsQuery();

  return useMemo(() => {
    return projects?.find(p => p.shortName === projectShortName)?.currency ?? '';
  }, [projectShortName, projects]);
}
